import { useState } from "react";
import { toast } from "sonner";
import { ThumbsUp, ThumbsDown, HeartHandshake, ChevronDown } from "lucide-react";
import { api, errMsg } from "../../lib/api";

export function QuickAttitude({ students }) {
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState({});
  const [sent, setSent] = useState({});
  const send = async (sid, thumb) => {
    try {
      await api.post("/daily-scores/attitude-quick", { student_id: sid, thumb, comment: notes[sid] || null });
      setSent((p) => ({ ...p, [sid]: thumb }));
      toast.success(thumb === "up" ? "👍 Sikap baik dicatat (+2)" : "👎 Catatan sikap dicatat (−2)");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-lg border border-rose-200 bg-rose-50/40 dark:bg-rose-950/20" data-testid="quick-attitude">
      <button type="button" data-testid="quick-attitude-toggle" onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-2 px-3 py-2 text-sm font-semibold">
        <HeartHandshake className="h-4 w-4 text-rose-600" />Catatan sikap cepat hari ini<span className="text-[11px] font-normal text-slate-500">👍 +2 · 👎 −2 poin, langsung masuk riwayat sikap</span><ChevronDown className={`h-4 w-4 ml-auto transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-3 pb-3 grid gap-1.5 sm:grid-cols-2">
        {students.map((s) => (
          <div key={s.id} className="flex items-center gap-2 rounded-md bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 px-2 py-1" data-testid="quick-attitude-row">
            <span className="text-sm font-medium flex-1 truncate">{s.name}</span>
            <input value={notes[s.id] || ""} onChange={(e) => setNotes((p) => ({ ...p, [s.id]: e.target.value }))} placeholder="komentar (opsional)" data-testid="quick-attitude-note" className="h-7 w-32 sm:w-40 rounded border border-slate-200 px-2 text-xs focus:outline-none focus:ring-1 focus:ring-rose-400" />
            <button type="button" data-testid="quick-attitude-up" onClick={() => send(s.id, "up")} className={`h-7 w-7 grid place-items-center rounded-full border transition-colors ${sent[s.id] === "up" ? "bg-emerald-600 text-white border-emerald-600" : "hover:bg-emerald-50 text-emerald-700 border-emerald-200"}`}><ThumbsUp className="h-3.5 w-3.5" /></button>
            <button type="button" data-testid="quick-attitude-down" onClick={() => send(s.id, "down")} className={`h-7 w-7 grid place-items-center rounded-full border transition-colors ${sent[s.id] === "down" ? "bg-red-600 text-white border-red-600" : "hover:bg-red-50 text-red-700 border-red-200"}`}><ThumbsDown className="h-3.5 w-3.5" /></button>
          </div>
        ))}
      </div>}
    </div>
  );
}
